import React, { Component } from 'react';
import { Select } from 'antd';
import { injectIntl } from 'react-intl';
import messages from './messages';

const Option = Select.Option;
const minAage = 14;
const maxAge = 100;
const ages = [];
for (let i = minAage; i <= maxAge; i++) {
	ages.push(i);
}

class TypeAge extends Component{
	constructor(props) {
		super(props);
		this.state = {
			ages: ages,
			value: '',
			error: false,
			message: props.intl.formatMessage(messages.errorMessage),
		};
	}
	
	validate = (value) => {
		const reg = /^-?(0|[1-9][0-9]*)?$/;
		return ((!isNaN(value) && reg.test(value)) || value === '-');
	};
	validateAge = (value) => {
		if ((value >= 14 && value <= 100)) {
			this.props.onChange(value);
			this.setState({ value, error: false });
		} else if (value > 100) {
			this.setState({ error: true });
		}
		else if (value === '') {
			this.setState({ value, error: true });
		}
		else {
			this.setState({ value, error: true });
		}
	};
	onChange = (value) => {
		if (this.validate(value)) {
			this.validateAge(value);
		} else {
			this.setState({ value: '' });
		}
	};
	
	render() {
		const { title, className } = this.props;
		const { error, message } = this.state;
		const options = this.state.ages.map(age => <Option key={age}>{age}</Option>);
		return (
			<span className={className}>
			<Select placeholder={title}
			        className={error ? 'inputError' : 'inputStyle'}
			        mode='combobox'
			        showSearch
			        value={this.state.value}
			        onChange={this.onChange}
			>
				{options}
		    </Select>
			<div className={`ErrorText ${ error ? ' visible' : null }`}>{message}</div>
        </span>
		);
	}
}

export default injectIntl(TypeAge);




// WEBPACK FOOTER //
// ./src/components/AnswerTypeAge/TypeAge.js